import React from 'react'
import PropTypes from 'prop-types'

const MinusIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>icons/document/minus</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <filter
        x="-90.0%"
        y="-90.0%"
        width="280.0%"
        height="280.0%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feOffset dx="0" dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="4.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.13 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g id="icons/document/minus" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="-" filter="url(#filter-1)">
        <path
          d="M2,0 L28,0 C29.1045695,-2.02906125e-16 30,0.8954305 30,2 L30,28 C30,29.1045695 29.1045695,30 28,30 L2,30 C0.8954305,30 1.3527075e-16,29.1045695 0,28 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
          id="Rectangle-6"
          fill="#FFFFFF"
        />
        <rect id="Rectangle-8" fill="#007AFA" x="8" y="14" width="14" height="2" />
      </g>
    </g>
  </svg>
)

MinusIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default MinusIcon
